export default function getLayerByName(map, name) {
	return map
		.getLayers()
		.getArray()
		.find(checkLayer => checkLayer.get('name') === name);
}
